/* Ink header: desktop mega menu and mobile menu sheet (sections/header-ink.liquid). */
(function () {
  'use strict';

  var root = document.querySelector('[data-hdr-ink]');
  if (!root) return;

  /* ---------- Desktop mega menu ---------- */
  var mega = root.querySelector('[data-hdr-mega]');
  if (mega) {
    var triggers = Array.prototype.slice.call(mega.querySelectorAll('[data-hdr-menu]'));
    var scrim = mega.querySelector('[data-hdr-scrim]');
    var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');
    var openId = null;
    var hoverTimer = null;

    var panelFor = function (id) { return document.getElementById(id); };

    var close = function () {
      if (!openId) return;
      var btn = mega.querySelector('[data-hdr-menu="' + openId + '"]');
      var panel = panelFor(openId);
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
      if (scrim) scrim.hidden = true;
      openId = null;
    };

    var open = function (id) {
      if (openId === id) return;
      close();
      var btn = mega.querySelector('[data-hdr-menu="' + id + '"]');
      var panel = panelFor(id);
      if (!btn || !panel) return;
      btn.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      if (scrim) scrim.hidden = false;
      openId = id;
    };

    triggers.forEach(function (btn) {
      var id = btn.getAttribute('data-hdr-menu');
      btn.addEventListener('click', function () {
        if (openId === id) close(); else open(id);
      });
      btn.addEventListener('mouseenter', function () {
        if (!hoverCapable.matches) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { open(id); }, 80);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          open(id);
          var first = panelFor(id) && panelFor(id).querySelector('a, button');
          if (first) first.focus();
        }
      });
    });

    /* Plain links in the bar close any open panel on hover, as in the design. */
    Array.prototype.forEach.call(mega.querySelectorAll('.hdr-megabar a.hdr-navbtn'), function (a) {
      a.addEventListener('mouseenter', function () {
        if (!hoverCapable.matches) return;
        clearTimeout(hoverTimer);
        close();
      });
    });

    mega.addEventListener('mouseleave', function () {
      if (!hoverCapable.matches) return;
      clearTimeout(hoverTimer);
      close();
    });
    if (scrim) scrim.addEventListener('click', close);

    mega.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !openId) return;
      var btn = mega.querySelector('[data-hdr-menu="' + openId + '"]');
      close();
      if (btn) btn.focus();
    });
    mega.addEventListener('focusout', function (e) {
      if (openId && e.relatedTarget && !mega.contains(e.relatedTarget)) close();
    });
    document.addEventListener('click', function (e) {
      if (openId && !mega.contains(e.target)) close();
    });
  }

  /* ---------- Mobile menu sheet ---------- */
  var drawer = document.getElementById('HeaderInkDrawer');
  if (!drawer) return;
  var views = Array.prototype.slice.call(drawer.querySelectorAll('[data-hdr-view-id]'));
  var lastTrigger = null;
  var lastRow = null;

  var showView = function (id) {
    views.forEach(function (v) { v.hidden = v.getAttribute('data-hdr-view-id') !== id; });
    var view = drawer.querySelector('[data-hdr-view-id="' + id + '"]');
    var body = view && view.querySelector('.hdr-dbody');
    if (body) body.scrollTop = 0;
    var focusTarget = view && (id === 'main' && lastRow && view.contains(lastRow) ? lastRow : view.querySelector('.hdr-dbar button, .hdr-dbar a'));
    if (focusTarget) focusTarget.focus();
  };

  var openDrawer = function (trigger) {
    lastTrigger = trigger || null;
    lastRow = null;
    drawer.hidden = false;
    document.documentElement.classList.add('hdr-locked');
    document.body.classList.add('sidebar-menu-open');
    root.querySelectorAll('[data-hdr-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    showView('main');
  };

  var closeDrawer = function () {
    if (drawer.hidden) return;
    drawer.hidden = true;
    document.documentElement.classList.remove('hdr-locked');
    document.body.classList.remove('sidebar-menu-open');
    root.querySelectorAll('[data-hdr-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastTrigger) lastTrigger.focus();
  };

  root.querySelectorAll('[data-hdr-open]').forEach(function (btn) {
    btn.addEventListener('click', function () { openDrawer(btn); });
  });

  drawer.addEventListener('click', function (e) {
    var t = e.target.closest('[data-hdr-close], [data-hdr-view]');
    if (!t) return;
    if (t.hasAttribute('data-hdr-close')) { closeDrawer(); return; }
    var id = t.getAttribute('data-hdr-view');
    if (id !== 'main') lastRow = t;
    showView(id);
  });

  drawer.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var view = views.filter(function (v) { return !v.hidden; })[0];
    if (!view) return;
    var items = Array.prototype.filter.call(
      view.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* theme.js re-renders only the first #HeaderCartIcon (the mobile one); mirror it to the desktop icon. */
  document.documentElement.addEventListener('cart:updated', function () {
    var source = document.getElementById('HeaderCartIcon');
    var mirror = root.querySelector('[data-hdr-cart-mirror]');
    if (source && mirror) mirror.innerHTML = source.innerHTML;
  });

  window.matchMedia('(min-width: 751px)').addEventListener('change', function (mq) {
    if (mq.matches) closeDrawer();
  });
})();
